import React, { useState, useEffect } from "react";
import { X, Zap } from "lucide-react";
import { useCruise } from "../context/CruiseContext";

const SAIL = new Date("2027-12-04T16:00:00-04:00");

const EarlyBirdBanner = () => {
  const { EVENT, EARLY_BIRD } = useCruise();
  const [open, setOpen] = useState(true);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(id);
  }, []);

  if (!open) return null;

  const DEADLINE = new Date(EARLY_BIRD.deadline);
  const daysToSail = Math.max(Math.floor((SAIL.getTime() - now) / (1000 * 60 * 60 * 24)), 0);
  const daysToDeadline = Math.ceil((DEADLINE.getTime() - now) / (1000 * 60 * 60 * 24));
  const active = daysToDeadline > 0;

  return (
    <div
      className={`fixed bottom-14 lg:bottom-0 left-0 w-full z-[60] shadow-[0_-4px_20px_rgba(0,0,0,0.4)] ${
        active ? "bg-[var(--hh-gold)] text-[#0A0A0A]" : "bg-[#E50914] text-white"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 py-2.5 flex items-center justify-center gap-3 text-center">
        <Zap size={16} className={`shrink-0 ${active ? "fill-[#0A0A0A]" : "fill-white"}`} />
        {active ? (
          <p className="font-cond uppercase tracking-wide text-xs sm:text-sm font-semibold">
            Early-Bird Offer — Hold your cabin for just {EARLY_BIRD.holdPrice} • Ends {EARLY_BIRD.deadlineLabel} ({daysToDeadline} days left)
            <a
              href={EVENT.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2 hover:opacity-80 ml-2"
            >
              Reserve now
            </a>
          </p>
        ) : (
          <p className="font-cond uppercase tracking-wide text-xs sm:text-sm font-semibold">
            Early-Bird has ended — reserve now with a {EVENT.depositFrom} deposit • {daysToSail} days until sail-away
            <a
              href={EVENT.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2 hover:opacity-80 ml-2"
            >
              Book now
            </a>
          </p>
        )}
        <button
          onClick={() => setOpen(false)}
          className="absolute right-4 top-1/2 -translate-y-1/2 hover:opacity-70"
          aria-label="Dismiss"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default EarlyBirdBanner;
